import { useState, useEffect } from "react";
import UsuariosService from "../../services/UsuariosService";
import { IUsuarioEmpresa, IUsuarios } from "../../interfaces/IUsuarios";
import EmpresasService from "../../services/EmpresasService";
import { Modal } from 'react-bootstrap-v5';
import clsx from "clsx";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import MaskedInput from "react-text-mask";
import { MASCARA_CPF, MASCARA_TELEFONE } from "../../utils/Constants";
import { useAuth } from "../../contexts/AuthProvider";

const UsuariosModal = ({ toggleModal, show, usuario, title }: { toggleModal: (loadItens?: boolean) => void, show: boolean, usuario: IUsuarios, title: string }) => {
    const [empresaSelecionada, setEmpresaSelecionada] = useState<any>();
    const [empresas, setEmpresas] = useState<any[]>([]);
    const [empresasVisualizacao, setEmpresasVisualizacao] = useState<any[]>([]);
    const [empresasAdicionadas, setEmpresasAdicionadas] = useState<any[]>([]);
    const [empresaAdicionadaSelecionada, setEmpresaAdicionadaSelecionada] = useState<any>();
    const [pesquisaEmpresa, setPesquisaEmpresa] = useState<string>('');
    const { usuario: usuarioLogado } = useAuth();

    const obrigacoesSchema = Yup.object().shape({
        nome: Yup.string().max(50, 'Maximo 50 caracteres').required('Descrição é obrigatório'),
        email: Yup.string().email().max(50, 'Maximo 50 caracteres').email('Esse e-mail não é válido').required('Descrição é obrigatório'),
        cpf: Yup.string().max(50, 'Maximo 50 caracteres').required('Descrição é obrigatório'),
        telefone: Yup.string().max(50, 'Maximo 50 caracteres').required('Descrição é obrigatório'),
        nomeUsuario: Yup.string().max(50, 'Maximo 50 caracteres').required('Descrição é obrigatório'),
        perfil: Yup.string().min(2).max(50, 'Maximo 50 caracteres').required('Descrição é obrigatório')
    })
    const initialValues = {
        id: 0,
        nome: '',
        email: '',
        cpf: '',
        telefone: '',
        nomeUsuario: '',
        perfil: ''
    } as IUsuarios;
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: obrigacoesSchema,
        onSubmit: async (values, { setSubmitting }) => {
            values.clienteID = usuarioLogado?.clienteID;

            if (values.id === 0) {
                values.empresas = empresasAdicionadas.map(e => {
                    return { empresaID: e.id, usuarioID: 0 } as IUsuarioEmpresa;
                });

                await UsuariosService.criar(values, () => toggleModal(true), 'Usuário foi adicionado com sucesso');
            } else {
                values.empresas = empresasAdicionadas.map(e => {
                    return { empresaID: e.id, usuarioID: values.id } as IUsuarioEmpresa;
                });

                await UsuariosService.atualizar(values, () => toggleModal(true), 'Usuário foi editado com sucesso');
            }

            setSubmitting(false);
        }
    });
    const perfilAdmin = [
        { id: '2', perfil: 'Administrador' },
        { id: '3', perfil: 'Analista' }
    ];

    useEffect(() => {
        formik.resetForm();

        if (usuario && usuario.id > 0) {
            formik.setValues(usuario);
            const result = empresas.filter((item) => {
                if (usuario.empresas) {
                    return usuario.empresas.filter((second) => second.empresaID === item.id).length > 0;
                } else {
                    return null
                }
            });

            const notExists = empresas.filter((item) => {
                if (usuario.empresas) {
                    return usuario.empresas.filter((second) => second.empresaID === item.id).length === 0;
                } else {
                    return null
                }
            });

            setEmpresasAdicionadas(result);
            setEmpresasVisualizacao(notExists);
        }

        !usuario.nome && formik.setFieldTouched('nome', false);
        !usuario.email && formik.setFieldTouched('email', false);
        !usuario.cpf && formik.setFieldTouched('cpf', false);
        !usuario.telefone && formik.setFieldTouched('telefone', false);
        !usuario.nomeUsuario && formik.setFieldTouched('nomeUsuario', false);
        !usuario.perfil && formik.setFieldTouched('perfil', false);

        // eslint-disable-next-line
    }, [usuario]);
    
    useEffect(() => {
        
        async function preCarregar() {
            if (usuarioLogado?.clienteID) {
                const todasEmpresas = await EmpresasService.obterTodosPorClienteID(usuarioLogado.clienteID | 0);
                
                setEmpresas(todasEmpresas);
                setEmpresasVisualizacao(todasEmpresas);
            }
        }
        
        preCarregar();
    }, []);
    
    useEffect(() => {
        if (pesquisaEmpresa === '' || pesquisaEmpresa === null || pesquisaEmpresa === undefined) {
            setEmpresasVisualizacao(empresas);
            
            return;
        }
        
        let novaEmpresasVisualizacao = empresas.filter(e => e.nome?.toLowerCase().indexOf(pesquisaEmpresa?.toLowerCase()) >= 0);
        
        setEmpresasVisualizacao(novaEmpresasVisualizacao);
        setEmpresaSelecionada(undefined);
        
        // eslint-disable-next-line
    }, [pesquisaEmpresa]);
    
    return <>
        <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title titulo-modal">{title}</h5>
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <i onClick={() => toggleModal()} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                    </div>
                </div>
                <div className="modal-body">
                    <form className="row g-3">
                        <div className="col-md-7">
                            <label htmlFor="form-nome" className="form-label required">Nome</label>
                            <input {...formik.getFieldProps('nome')} placeholder="Nome Completo" type="text" className={clsx(
                                'form-control',
                                {
                                    'is-invalid': formik.touched.nome && formik.errors.nome,
                                },
                                {
                                    'is-valid': formik.touched.nome && !formik.errors.nome,
                                }
                            )} id="form-nome" />
                        </div>
                        <div className="col-md-5">
                            <label htmlFor="form-email" className="form-label required">E-mail</label>
                            <input {...formik.getFieldProps('email')} placeholder="exemplo@email.com" type="text" className={clsx(
                                'form-control',
                                {
                                    'is-invalid': formik.touched.email && formik.errors.email,
                                },
                                {
                                    'is-valid': formik.touched.email && !formik.errors.email,
                                }
                            )} id="form-email" />
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="form-usuario" className="form-label required mt-5">Nome de Usuário</label>
                            <input {...formik.getFieldProps('nomeUsuario')} placeholder="Digite Algo" type="text" className={clsx(
                                'form-control',
                                {
                                    'is-invalid': formik.touched.nomeUsuario && formik.errors.nomeUsuario,
                                },
                                {
                                    'is-valid': formik.touched.nomeUsuario && !formik.errors.nomeUsuario,
                                }
                            )} id="form-usuario" />
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="form-cpf" className="form-label required mt-5">CPF</label>
                            <MaskedInput mask={MASCARA_CPF} {...formik.getFieldProps('cpf')} placeholder="000.000.000-00" type="text" className={clsx(
                                'form-control',
                                {
                                    'is-invalid': formik.touched.cpf && formik.errors.cpf,
                                },
                                {
                                    'is-valid': formik.touched.cpf && !formik.errors.cpf,
                                }
                            )} id="form-cpf" />
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="form-telefone" className="form-label required mt-5">Telefone</label>
                            <MaskedInput mask={MASCARA_TELEFONE} {...formik.getFieldProps('telefone')} placeholder="(00)0000-0000" type="text" className={clsx(
                                'form-control',
                                {
                                    'is-invalid': formik.touched.telefone && formik.errors.telefone,
                                },
                                {
                                    'is-valid': formik.touched.telefone && !formik.errors.telefone,
                                }
                            )} id="form-telefone" />
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="form-perfil" className="form-label required mt-5">Perfil</label>
                            <select id="form-perfil"
                                {...formik.getFieldProps('perfil')}
                                onChange={async e => await formik.setFieldValue(e.target.name, e.target.value)} className="form-select">
                                <option value="" hidden>Selecione</option>
                                {
                                    perfilAdmin.length > 0 && perfilAdmin.map((x, index) => <option key={index} value={x.perfil}>{x.perfil}</option>)
                                }
                            </select>
                            <label style={{ color: 'red' }} hidden={!(formik.touched.perfil && formik.errors.perfil)}>{formik.errors.perfil}</label>
                        </div>
                    </form>
                    <div style={{ display: 'flex', marginTop: '30px' }}>
                        <div className="col-md-5 ms-5" style={{ border: '1px solid #DFDFDF', textAlign: 'left', borderRadius: '10px', padding: '10px', margin: '0' }}>
                            <h1 className="azul-agriholmes mt-5 mb-5" style={{ textAlign: 'center' }}>Empresas Vinculadas</h1>
                            {
                                empresasAdicionadas.map((x, index) => {
                                    function acaoTocarEmpresasAdicionadas() {
                                        if (empresaAdicionadaSelecionada?.id === x.id) {
                                            setEmpresaAdicionadaSelecionada(null);

                                            return;
                                        }

                                        setEmpresaAdicionadaSelecionada(x);
                                        setEmpresaSelecionada(null);
                                    }

                                    return <p key={index} className="parametrizacao-item" onClick={acaoTocarEmpresasAdicionadas}>{x.nomeFantasia || x.razaoSocial}</p>
                                })
                            }
                        </div>
                        <div className="col-md-1 align-items-center ms-1 mx-1" style={{ padding: '10px', margin: '0', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <div className='align-items-center py-1'>
                                <button disabled={empresaSelecionada == null} onClick={() => {
                                    const novasEmpresas = empresas.filter(r => r.id !== empresaSelecionada.id);
                                    let novasEmpresasAdicionadas = empresasAdicionadas;

                                    novasEmpresasAdicionadas.push(empresaSelecionada);
                                    novasEmpresasAdicionadas = novasEmpresasAdicionadas.sort((a, b) => a.nome > b.nome ? 1 : -1);

                                    setEmpresas(novasEmpresas);
                                    setEmpresaSelecionada(null);
                                    setEmpresasVisualizacao(novasEmpresas);
                                    setEmpresasAdicionadas(novasEmpresasAdicionadas);
                                }} className='btn btn-sm btn-primario'>
                                    <i className="text-white fa fa-arrow-left"></i>
                                </button>
                            </div>
                            <div className='align-items-center py-1'>
                                <button disabled={empresaAdicionadaSelecionada == null} onClick={() => {
                                    const novasEmpresasAdicionadas = empresasAdicionadas.filter(r => r.id !== empresaAdicionadaSelecionada.id);
                                    let novasEmpresas = empresas;

                                    novasEmpresas.push(empresaAdicionadaSelecionada);
                                    novasEmpresas = novasEmpresas.sort((a, b) => a.nome > b.nome ? 1 : -1);

                                    setEmpresas(novasEmpresas);
                                    setEmpresasVisualizacao(novasEmpresas);
                                    setEmpresaAdicionadaSelecionada(null);
                                    setEmpresasAdicionadas(novasEmpresasAdicionadas);
                                }} className='btn btn-sm btn-primario'>
                                    <i className="text-white fa fa-arrow-right"></i>
                                </button>
                            </div>
                        </div>
                        <div className="col-md-5" style={{ border: '1px solid #DFDFDF', textAlign: 'left', borderRadius: '10px', padding: '10px' }}>
                            <h1 className="azul-agriholmes mt-5 mb-5" style={{ textAlign: 'center' }}>Todas as Empresas</h1>
                            <div style={{ border: '1px solid #DDD', borderRadius: '10px', padding: '10px' }}>
                                <i className="bi bi-search" />
                                <input onChange={(e) => setPesquisaEmpresa(e.target.value)} placeholder="Digite Algo" style={{ border: 'none', outline: 'none', width: '90%', marginLeft: '5px' }} />
                            </div>
                            <div style={{ overflow: 'auto', minHeight: '200px', maxHeight: '200px' }} onLoad={() => setPesquisaEmpresa('')}>
                                {
                                    empresasVisualizacao.length > 0
                                        ?
                                        empresasVisualizacao.map((x, index) => {
                                            function acaoTocarEmpresasVisualizacao() {
                                                if (empresaSelecionada?.id === x.id) {
                                                    setEmpresaSelecionada(null);

                                                    return;
                                                }

                                                setEmpresaSelecionada(x);
                                                setEmpresaAdicionadaSelecionada(null);
                                            }

                                            return <p key={index} onClick={acaoTocarEmpresasVisualizacao} className="parametrizacao-item">{x.nomeFantasia || x.razaoSocial}</p>
                                        })
                                        :
                                        <p className="mt-5 ms-5">Não foi encontrada nenhuma empresa</p>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer" style={{ margin: '0 auto' }}>
                    <button disabled={formik.isSubmitting} onClick={() => toggleModal()} type="button" className="btn btn-modal-cancelar me-5"> CANCELAR </button>
                    <button disabled={formik.isSubmitting || !formik.isValid} onClick={() => { formik.submitForm() }} type="button" className="btn btn-primario ms-5">
                        {!formik.isSubmitting && <> {usuario?.id ? 'EDITAR' : 'ADICIONAR'} </>}
                        {formik.isSubmitting && (
                            <span className='indicator-progress' style={{ display: 'block' }}>
                                Salvando...
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                        )}
                    </button>
                </div>
            </div>
        </Modal>
    </>
}

export default UsuariosModal;